import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/toxicologia/registro-reach-y-apoyo-al-cumplimiento")({
  beforeLoad: () => { throw redirect({ href: "/es/servicios/toxicologia-regulatoria/registro-reach-y-apoyo-al-cumplimiento", statusCode: 301 }); },
});
